/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetAdminAccessRights$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminAccessRightsRequest = createAction<PayloadData<void>>('GET_ADMIN_ACCESS_RIGHTS__GET_ADMIN_ACCESS_RIGHTS__REQUEST');
export const getAdminAccessRightsSuccess = createAction<PayloadData<Array<string>>>('GET_ADMIN_ACCESS_RIGHTS__GET_ADMIN_ACCESS_RIGHTS__SUCCESS');
export const getAdminAccessRightsFailure = createAction<PayloadData<Error, void, true>>('GET_ADMIN_ACCESS_RIGHTS__GET_ADMIN_ACCESS_RIGHTS__FAILURE');

export const getAdminAccessRightsActions = [
    getAdminAccessRightsRequest,
    getAdminAccessRightsSuccess,
    getAdminAccessRightsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminAccessRights = (config?: GetAdminAccessRights$Config) => {
    return {
        CALL_API: {
            types: getAdminAccessRightsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/access-rights`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

